enum WorkTypes {
  Inspection = 'Inspection',
  Repair = 'Repair',
  Replacement = 'Replacement',
  Installation = 'Installation',
}
export default WorkTypes;
